var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSinagogue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 37,
    viewBox: "0 0 21 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EDEBE5",
    d: "M11.725 2.91l.746-1.291c.109-.188-.028-.424-.245-.424h-1.49L10.126.142c-.108-.19-.38-.19-.49 0L9.03 1.195H7.54c-.217 0-.353.236-.244.424l.745 1.29-.745 1.29c-.11.189.027.425.245.425h1.49l.607 1.053c.11.189.382.189.49 0l.608-1.053h1.49c.218 0 .355-.236.246-.424l-.746-1.29z",
    transform: "translate(.604 .18)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C9BDBA",
    d: "M9.883 7.676c-4.187 0-7.581 3.394-7.581 7.581h15.161c0-4.187-3.394-7.58-7.58-7.58",
    transform: "translate(.604 .18)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDEBE5",
    d: "M17.184 16.16H2.58C1.156 16.16 0 17.315 0 18.74v17.184h7.106V24.047c0-1.534 1.243-2.777 2.777-2.777 1.533 0 2.776 1.243 2.776 2.777v11.878h7.106V18.74c0-1.426-1.156-2.581-2.581-2.581",
    transform: "translate(.604 .18)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSinagogue);
export default __webpack_public_path__ + "static/media/sinagogue.c5cb14ca78abebb20f6e90f5bf3afce0.svg";
export { ForwardRef as ReactComponent };